/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useNavigate, useSearchParams, useParams, useLocation } from "react-router-dom";
import DefaultApi from "../../api/default";
import SystemModuleApi from "../../api/systemModuleApi";
import { usePopup } from "../../contexts/PopupContext";
import IframeModal from "../IframeModal";
import {
  AppBar,
  Toolbar,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Box,
  Drawer,
  useMediaQuery,
  Typography,
  Collapse,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Tooltip,
  Popover,
  ListSubheader,
} from "@mui/material";
import EntityModal from "../EntityModal";
import {
  Menu as MenuIcon,
  ExpandLess,
  ExpandMore,
  AccountCircle,
  Dashboard,
  AttachMoney,
  Assessment,
  PersonAddAlt1,
  DesignServices,
  Engineering,
  SwapHoriz,
  SubdirectoryArrowRight,
  TrendingUp,
  BarChart,
  Storefront,
  DnsSharp,
  VpnKey,
  FactCheck,
  MonitorHeart,
  PersonAddAlt,
  HowToReg,
  QueryStats,
  RequestQuote,
  EmojiEvents,
  ChevronRight,
  CreateOutlined,
  BuildOutlined,
  Security,
  NotificationsActive,
  Publish,
  Storage as StorageIcon,
} from "@mui/icons-material";
import MessageIcon from "@mui/icons-material/Message";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import "./style.css";
import logoInicial from "../../img/logo.png";
import EditNoteIcon from "@mui/icons-material/EditNote";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import TableBarIcon from "@mui/icons-material/TableBar";
import StyleIcon from "@mui/icons-material/Style";
import { PanelLeft } from "lucide-react";
import ViewsApi from "api/views";
import { createJsonFile } from "../../store/utils/entityUtils";
import MonacoEditor from "components/MonacoEditor";
import { Button as BsButton } from "react-bootstrap";
import GlobalSearch from "../GlobalSearch";
import GlobalSearchModal from "../GlobalSearchModal";
import tokenManager from "../../utils/tokenManager";
import { redirectToSsoLogin } from "../../utils/sso";
import { useMaker, SIDEBAR_STATES } from "../../contexts/MakerContext";
import { generalRoutes } from "../../routes/routes";

const MENU_STATES = {
  EXPANDED: "expanded",
  COLLAPSED: "collapsed",
  HIDDEN: "hidden",
};

// 🌐 Base URL para navegação do menu
const MENU_BASE_URL = process.env.REACT_APP_MENU_BASE_URL || 'https://app.myplat.net.br';

const SlimMenuBar = ({ hideMenu, children, forceMenuState }) => {
  const logout = useStoreActions((action) => action.auth.logout);
  const tenant = useStoreState((state) => state.auth.tenantLabel);
  const makerVersion = useStoreState((state) => state.auth.makerVersion);
  const isPersonalizationMode = useStoreState((state) => state.auth.isPersonalizationMode);
  const personalizationTenantId = useStoreState((state) => state.auth.personalizationTenantId);
  const navigate = useNavigate();
  const location = useLocation();
  const { sidebarState, handleCycleSidebarState } = useMaker();
  
  // Detectar rota atual e buscar configuração
  const currentRoute = generalRoutes.find(route => route.path === location.pathname);
  const pageTitle = currentRoute?.title || '';
  const pageSubtitle = currentRoute?.subtitle || '';
  const isMakerPage = location.pathname === '/maker';
  
  // Parse token payload for tooltip info (application, systemVersion, systemVersionMaker)
  const parseJwt = (token) => {
    try {
      const base64Url = token?.split('.')[1];
      const base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    } catch (e) {
      return {};
    }
  };

  const tokenPayload = parseJwt(tokenManager.getToken());
  const tooltipApp = tokenPayload?.application || tokenPayload?.applicaton || '';
  const tooltipSystemVersion = tokenPayload?.systemVersion || tokenPayload?.systemVersionMaker || tokenPayload?.systemVersion || '';
  const tooltipSystemVersionMaker = tokenPayload?.systemVersionMaker || tokenPayload?.systemVersionMaker || '';

  const isProd = process.env.REACT_APP_ENV === 'prd';

  // 📂 Hooks do popup
  const { popupEnabled, popupUrl, popupTitle, openPopup, closePopup } = usePopup();

  // 🔗 Função auxiliar para propagar querystrings
  const buildUrlWithQueryString = (url) => {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const isInIframe = currentSearchParams.get('hideMenu') === 'true';
    if (isInIframe) {
      return url.includes('?') ? `${url}&hideMenu=true` : `${url}?hideMenu=true`;
    }
    return url;
  };

  // ⌨️ Mapa de atalhos de teclado
  const [keyboardShortcuts, setKeyboardShortcuts] = useState(new Map());

  const [searchParams] = useSearchParams();
  const params = useParams();

  const hide = searchParams.get("hideMenu") === "true";

  const [menuJson, setMenuJson] = useState([]);
  const [parentMenus, setParentMenus] = useState([]);
  const [openMenus, setOpenMenus] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [anchorParams, setAnchorParams] = useState(null);

  const [openEditor, setOpenEditor] = useState(false);
  const [editorValue, setEditorValue] = useState("");
  const [view, setView] = useState(null);

  const getView = () => {
    // VALIDAÇÃO: Garante que nunca envie undefined
    const screenName = params.screen && params.screen !== 'undefined' ? params.screen : 'home';

    ViewsApi.get(screenName)
      .then((response) => {
        setView({
          name: params.screen || response.data?.name,
          view: response.data.view,
        });
      })
      .catch((error) => {
        console.error("Erro ao buscar a view:", error);
        setView({
          name: params.screen || 'home',
          view: {},
        });
      });
  };

  const handleEditEntity = () => {
    const entityConfig = view?.view;
    if (entityConfig) {
      // console.log("Editing view:", entityConfig);
      const configJson = JSON.stringify(entityConfig, null, 2);
      setEditorValue(configJson);
      setOpenEditor(true);
    } else {
      setEditorValue("{}");
      setOpenEditor(true);
    }
  };

  const handleSaveEntity = async (newConfig) => {
    // console.log("Salvando nova configuração da view:", newConfig);
    const file = createJsonFile(JSON.parse(newConfig), `${view.name}.json`);
    ViewsApi.upload(view?.name, file)
      .then((response) => {
        setView((current) => ({
          ...current,
          view: JSON.parse(newConfig),
        }));
        setOpenEditor(false);
      })
      .catch((error) => {
        console.error("Erro ao salvar configuração:", error);
      });
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [submenuPopovers, setSubmenuPopovers] = useState([]);

  // Reabre o EntityModal quando voltamos das telas de criação/edição
  // EXCETO quando vem do Maker (fromMaker: true)
  useEffect(() => {
    if (location.state?.openEntityModal && !location.state?.fromMaker) {
      setModalOpen(true);
      // Limpa o state para evitar reabrir sempre
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const openSubmenuPopover = (anchorEl, menuItem, childMenus, level) => {
    setSubmenuPopovers((prev) => [
      ...prev.filter((p) => p.level < level), // Remove popovers of equal or higher level
      {
        id: `${menuItem.menu}_${level}`,
        open: true,
        anchorEl,
        menuItem,
        childMenus,
        level,
      },
    ]);
  };

  const closeSubmenuPopover = (level = null) => {
    if (level === null) {
      setSubmenuPopovers([]);
    } else {
      setSubmenuPopovers((prev) => prev.filter((p) => p.level < level));
    }
  };

  const closeAllSubmenuPopovers = () => {
    setSubmenuPopovers([]);
  };

  // const handlePopoverMouseLeave = (level) => {
  //   setTimeout(() => {
  //     const popoverElements = document.querySelectorAll('[data-testid^="nested-submenu-popover"]');
  //     let isMouseOverPopover = false;

  //     popoverElements.forEach(el => {
  //       const rect = el.getBoundingClientRect();
  //       const mouseX = window.mouseX || 0;
  //       const mouseY = window.mouseY || 0;

  //       if (mouseX >= rect.left && mouseX <= rect.right &&
  //           mouseY >= rect.top && mouseY <= rect.bottom) {
  //         isMouseOverPopover = true;
  //       }
  //     });

  //     if (!isMouseOverPopover) {
  //       closeSubmenuPopover(level);
  //     }
  //   }, 300);
  // };

  React.useEffect(() => {
    const handleMouseMove = (e) => {
      window.mouseX = e.clientX;
      window.mouseY = e.clientY;
    };
    document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    // console.log("params changed:", params);
    getView();
  }, [params.screen]);

  // const getMenuDepth = (menuItem, currentDepth = 0) => {
  //   const children = menuJson.filter((e) => e.parentmenu === menuItem.menu);
  //   if (children.length === 0) return currentDepth;

  //   return Math.max(...children.map(child => getMenuDepth(child, currentDepth + 1)));
  // };

  // Função para carregar o estado salvo do menu ou usar o padrão (recolhido)
  const getInitialMenuState = () => {
    const savedState = localStorage.getItem('menuState');
    if (savedState && Object.values(MENU_STATES).includes(savedState)) {
      return savedState;
    }
    // Estado padrão é recolhido quando usuário não salvou preferência
    return MENU_STATES.COLLAPSED;
  };

  const [menuState, setMenuState] = useState(getInitialMenuState);

  // If a parent wants to force the menu state (e.g. hidden when entering a route),
  // apply it on mount and restore the previous state on unmount.
  const initialMenuStateRef = React.useRef(menuState);
  useEffect(() => {
    if (!forceMenuState) return;
    // save current state to restore later
    initialMenuStateRef.current = menuState;
    setMenuState(forceMenuState);
    return () => {
      setMenuState(initialMenuStateRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceMenuState]);

  const toggleMenuState = () => {
    closeAllSubmenuPopovers();
    const states = [
      MENU_STATES.EXPANDED,
      MENU_STATES.COLLAPSED,
      MENU_STATES.HIDDEN,
    ];
    const currentIndex = states.indexOf(menuState);
    const nextIndex = (currentIndex + 1) % states.length;
    const nextState = states[nextIndex];

    // Salva o novo estado no localStorage
    localStorage.setItem('menuState', nextState);
    setMenuState(nextState);
  };

  const getDrawerWidth = () => {
    if (menuState === MENU_STATES.HIDDEN) return 0;
    if (menuState === MENU_STATES.COLLAPSED) return 64;
    return 240;
  };

  const getMenuIcon = (menuItem, level) => {
    if (menuItem.icon) {
      return <i className={menuItem.icon} />;
    }
    const mainIconMap = {
      Cadastro: <PersonAddAlt1 />,
      Finanças: <AttachMoney />,
      Relatórios: <Assessment />,
      "Centro de Criação": <DesignServices />,
      Processos: <Engineering />,
      Movimentação: <SwapHoriz />,
    };

    const subIconMap = {
      // Submenus de Cadastro
      Financeiro: <AttachMoney />,
      Comercial: <Storefront />,
      Sistema: <DnsSharp />,
      "Outros cadastros": <PersonAddAlt />,

      // Submenus de Finanças
      Matricula: <HowToReg />,

      // Submenus de Relatórios
      "Fluxo de Caixa": <TrendingUp />,
      Gerencial: <BarChart />,
      "Gerencial Analitico": <QueryStats />,

      // Submenus de Processos
      "Gerar Financeiro Matricula": <RequestQuote />,
      "Status Competicao": <EmojiEvents />,
    };

    if (level === 0) {
      return mainIconMap[menuItem.menu] || <Dashboard />;
    }
    return subIconMap[menuItem.menu] || <SubdirectoryArrowRight />;
  };

  const closeModal = (data) => {
    // console.log("RETORNO MODAL:", data);
    setModalOpen(false);
  };

  const handleMenuToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLogout = async () => {
    logout();
    redirectToSsoLogin();
  };

  function redirectModalOpen() {
    closeSettingsMenu();
    setModalOpen(true);
  }

  const toggleSubMenu = (menu) => {
    setOpenMenus((prev) =>
      prev.includes(menu) ? prev.filter((m) => m !== menu) : [...prev, menu]
    );
  };

  // 📂 Função para navegar considerando o modo popup
  const handleNavigation = (url, title = '') => {
    // console.log('🔗 Navegando:', { url, popupEnabled, title });

    if (popupEnabled) {
      // Se popup está habilitado, abre em iframe usando base URL configurada
      const baseUrl = `${MENU_BASE_URL}/home/${url}`;
      const fullUrl = baseUrl.includes('?') ? `${baseUrl}&hideMenu=true` : `${baseUrl}?hideMenu=true`;
      openPopup(fullUrl, title);
    } else {
      // Navegação normal - propaga hideMenu se estiver ativo
      navigate(buildUrlWithQueryString(`/home/${url}`));
    }
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setAnchorParams(null);
  };

  const handleSubmenuClick = (event, menuItem, level = 1) => {
    if (menuState === MENU_STATES.COLLAPSED) {
      const childMenus = menuJson.filter((e) => e.parentmenu === menuItem.menu);
      if (childMenus.length > 0) {
        openSubmenuPopover(event.currentTarget, menuItem, childMenus, level);
      } else {
        handleNavigation(menuItem.url, menuItem.menu);
        closeAllSubmenuPopovers();
      }
    }
  };

  const handleNestedSubmenuClick = (event, childItem, currentLevel) => {
    event.stopPropagation();
    const grandChildMenus = menuJson.filter(
      (e) => e.parentmenu === childItem.menu
    );

    if (grandChildMenus.length > 0) {
      openSubmenuPopover(
        event.currentTarget,
        childItem,
        grandChildMenus,
        currentLevel + 1
      );
    } else {
      handleNavigation(childItem.url, childItem.menu);
      closeAllSubmenuPopovers();
    }
  };

  const openSettingsMenu = (event) => {
    setAnchorParams(event.currentTarget);
  };

  const closeSettingsMenu = (path) => {
    setAnchorParams(null);

    if (path)
      setTimeout(() => {
        navigate(buildUrlWithQueryString(path));
      }, 500);
  };

  useEffect(() => {
    const getMenu = async () => {
      try {
        // Menus vêm do SSO (/system-module/full) — endpoint /default/menu foi removido
        const json = await SystemModuleApi.getModulesFull();
        const allMenus = (json.data ?? []).flatMap((mod) =>
          (mod.menus ?? []).map((item) => ({
            ...item,
            menu: item.menu ?? item.label,
          }))
        );
        setMenuJson(allMenus);
        setParentMenus(allMenus.filter((e) => !e.parentmenu));

        // ⌨️ Criar mapa de atalhos de teclado
        const shortcutMap = new Map();
        allMenus.forEach((menuItem) => {
          if (menuItem.key_board_short_cut) {
            shortcutMap.set(menuItem.key_board_short_cut.toLowerCase(), {
              url: menuItem.url,
              title: menuItem.menu,
            });
          }
        });
        setKeyboardShortcuts(shortcutMap);
      } catch (error) {
        console.error("Erro ao buscar os dados:", error);
      }
    };

    getMenu();
  }, []);

  // Mapeamento de atalhos de teclado do menu
  //  const keyboardShortcuts = useMemo(() => {
  //    const shortcuts = {};
  //    if (menuJson && menuJson.length > 0) {
  //      menuJson.forEach((menuItem) => {
  //        if (menuItem?.keyboardShortcutMenu) {
  //         shortcuts[menuItem.keyboardShortcutMenu.toLowerCase()] = menuItem;
  //        }
  //      });
  //    }
  //    return shortcuts;
  //  }, [menuJson]);

  useEffect(() => {
    if (Object.keys(keyboardShortcuts).length > 0) {
      const handleGlobalKeyDown = (event) => {
        const keys = [];
        if (event.ctrlKey) keys.push("ctrl");
        if (event.altKey) keys.push("alt");
        if (event.shiftKey) keys.push("shift");
        keys.push(event.key.toLowerCase());
        const shortcut = keys.join("+");

        const menuItem = keyboardShortcuts[shortcut];
        if (menuItem) {
          event.preventDefault();

          if (menuItem.url) {
            handleNavigation(menuItem.url, menuItem.menu);
            closeAllSubmenuPopovers();
          }
        }
      };

      document.addEventListener("keydown", handleGlobalKeyDown);
      return () => {
        document.removeEventListener("keydown", handleGlobalKeyDown);
      };
    }
  }, [keyboardShortcuts, handleNavigation]);

  useEffect(() => {
    if (menuState !== MENU_STATES.COLLAPSED) {
      closeAllSubmenuPopovers();
    }
  }, [menuState]);

  // ⌨️ Listener global de atalhos de teclado
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Ignora se estiver digitando em input/textarea
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      // Monta a string da combinação de teclas
      const keys = [];
      if (event.ctrlKey) keys.push('ctrl');
      if (event.altKey) keys.push('alt');
      if (event.shiftKey) keys.push('shift');

      // Adiciona a tecla principal (não modificadores)
      if (event.key && !['Control', 'Alt', 'Shift'].includes(event.key)) {
        keys.push(event.key.toLowerCase());
      }

      const shortcutKey = keys.join('+');

      // Verifica se existe um atalho cadastrado
      const shortcutData = keyboardShortcuts.get(shortcutKey);
      if (shortcutData) {
        event.preventDefault();
        // console.log('⌨️ Atalho detectado:', shortcutKey, '→', shortcutData.title);
        handleNavigation(shortcutData.url, shortcutData.title);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [keyboardShortcuts, handleNavigation]);

  const handleSubmenuToggle = (parent) => {
    const filteredSubmenus = menuJson.filter(
      (child) => child.parentmenu === parent.menu
    );

    if (filteredSubmenus.length > 0) {
      toggleSubMenu(parent.menu);
    } else {
      navigate(buildUrlWithQueryString(`/home/${parent.url}`));
    }
  };

  // ⌨️ Renderizar badge de atalho
  const renderShortcutBadge = (shortcut) => {
    if (!shortcut) return null;
    return (
      <Box
        component="span"
        sx={{
          ml: 'auto',
          px: 1,
          py: 0.3,
          fontSize: '0.65rem',
          fontWeight: 700,
          backgroundColor: '#782cdf',
          color: 'white',
          borderRadius: '4px',
          fontFamily: 'monospace',
          letterSpacing: '1px',
          whiteSpace: 'nowrap',
          display: 'inline-block'
        }}
      >
        {shortcut.toUpperCase()}
      </Box>
    );
  };

  const renderMenu = (menuItem, pIndex, level) => {
    const childMenus = menuJson.filter((e) => e.parentmenu === menuItem.menu);
    const isCollapsed = menuState === MENU_STATES.COLLAPSED;
    return (
      <>
        {childMenus.length === 0 ? (
          <Tooltip title={isCollapsed ? menuItem.menu : ""} placement="right">
            <ListItemButton
              onClick={() => handleNavigation(menuItem.url, menuItem.menu)}
              sx={{
                pl: isCollapsed ? 1 : 4 * level,
                cursor: "pointer",
                justifyContent: isCollapsed ? "center" : "flex-start",
                minHeight: 48,
              }}
            >
              <ListItemIcon sx={{ minWidth: isCollapsed ? "auto" : 56 }}>
                {getMenuIcon(menuItem, level)}
              </ListItemIcon>
              {!isCollapsed && (
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      <span>{menuItem.menu}</span>
                      {renderShortcutBadge(menuItem.key_board_short_cut)}
                    </Box>
                  }
                />
              )}
            </ListItemButton>
          </Tooltip>
        ) : (
          <React.Fragment key={pIndex}>
            <Tooltip title={isCollapsed ? menuItem.menu : ""} placement="right">
              <ListItemButton
                onClick={(event) =>
                  isCollapsed
                    ? handleSubmenuClick(event, menuItem)
                    : handleSubmenuToggle(menuItem)
                }
                sx={{
                  backgroundColor: openMenus.includes(menuItem.menu)
                    ? "#f0f0f0"
                    : "transparent",
                  transition: "background-color 0.3s ease",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                  cursor: "pointer",
                  justifyContent: isCollapsed ? "center" : "flex-start",
                  minHeight: 48,
                }}
              >
                <ListItemIcon sx={{ minWidth: isCollapsed ? "auto" : 56 }}>
                  {getMenuIcon(menuItem, level)}
                </ListItemIcon>
                {!isCollapsed && (
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <span>{menuItem.menu}</span>
                        {renderShortcutBadge(menuItem.key_board_short_cut)}
                      </Box>
                    }
                    primaryTypographyProps={{
                      style: { fontWeight: 500, paddingLeft: level * 16 },
                    }}
                  />
                )}
                {!isCollapsed &&
                  childMenus.length > 0 &&
                  (openMenus.includes(menuItem.menu) ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  ))}
              </ListItemButton>
            </Tooltip>
            {!isCollapsed && (
              <Collapse
                in={openMenus.includes(menuItem.menu)}
                timeout="auto"
                unmountOnExit
                sx={{
                  "& .MuiCollapse-wrapper": {
                    transition: "transform 0.3s ease",
                  },
                }}
              >
                <List component="div" disablePadding>
                  {childMenus.map((childItem, cIndex) => (
                    <React.Fragment key={cIndex}>
                      {renderMenu(childItem, cIndex, level + 1)}
                    </React.Fragment>
                  ))}
                </List>
              </Collapse>
            )}
            <Divider />
          </React.Fragment>
        )}
      </>
    );
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <MonacoEditor
        open={openEditor}
        onClose={() => setOpenEditor(false)}
        initialValue={editorValue}
        onSave={handleSaveEntity}
        language="json"
        title={`Editar Configuração da View: ${view?.name}`}
      />
      <EntityModal open={modalOpen} onClose={closeModal} />

      {/* 📂 Modal com Iframe */}
      <IframeModal
        open={!!popupUrl}
        onClose={closePopup}
        url={popupUrl}
        title={popupTitle}
      />
      {!hide && !hideMenu && menuState !== MENU_STATES.HIDDEN && (
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={isMobile ? drawerOpen : true}
          onClose={isMobile ? handleMenuToggle : undefined}
          sx={{
            "& .MuiDrawer-paper": {
              width: getDrawerWidth(),
              boxSizing: "border-box",
              backgroundColor: "#f4f4f4",
              borderRight: "none",
              overflowY: "auto",
              transition: "width 0.3s ease",
            },
            height: "100vh",
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              height: 64,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#782cdf",
              borderBottom: "none",
            }}
          >
            {menuState === MENU_STATES.EXPANDED ? (
              <img src={logoInicial} alt="logo" style={{ height: 64 }} />
            ) : (
              <img
                src={logoInicial}
                alt="logo"
                style={{ height: 40, width: 40 }}
              />
            )}
          </Box>
          <List>
            {menuJson.length > 0 ? (
              parentMenus.map((parent, pIndex) => (
                <React.Fragment key={pIndex}>
                  {renderMenu(parent, pIndex, 0)}
                </React.Fragment>
              ))
            ) : (
              <ListItem>
                {menuState === MENU_STATES.EXPANDED ? "Carregando..." : "..."}
              </ListItem>
            )}
          </List>
        </Drawer>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          height: "100vh",
        }}
      >
        {isPersonalizationMode && (
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 1300,
              backgroundColor: '#ff9800',
              color: '#fff',
              textAlign: 'center',
              py: 0.5,
              px: 2,
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: 0.3,
              boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            }}
          >
            Modo Personalização — Tenant: {personalizationTenantId || tenant}
          </Box>
        )}
        {!hide && !hideMenu && (
          <AppBar
            position="sticky"
            sx={{ backgroundColor: isProd ? '#b71c1c' : '#782cdf', zIndex: 1200 }}
          >
            <Toolbar>
              {!isMobile && (
                <Tooltip
                  title={`Menu: ${menuState === MENU_STATES.EXPANDED
                    ? "Estendido"
                    : menuState === MENU_STATES.COLLAPSED
                      ? "Recolhido"
                      : "Escondido"
                    }`}
                >
                  <IconButton
                    color="inherit"
                    edge="start"
                    onClick={toggleMenuState}
                    sx={{ mr: 2 }}
                  >
                    <PanelLeft size={20} />
                  </IconButton>
                </Tooltip>
              )}

              {isMobile && (
                <IconButton
                  color="inherit"
                  edge="start"
                  onClick={handleMenuToggle}
                >
                  <MenuIcon />
                </IconButton>
              )}
              {!isMobile && (
                <IconButton
                  color="inherit"
                  edge="start"
                  onClick={() => navigate("/maker")}
                >
                  <img
                    src={logoInicial}
                    alt="logo"
                    style={{ height: 40, marginRight: 8, marginLeft: 40 }}
                  />
                </IconButton>
              )}
              <Typography
                variant="h6"
                sx={{ flexGrow: 1, textAlign: "center", fontWeight: "bold", display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}
              >
                {pageTitle && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ fontSize: '1.1rem' }}>{pageTitle}</span>
                    {pageSubtitle && (
                      <span style={{ fontSize: '0.75rem', fontWeight: 'normal', opacity: 0.9 }}>{pageSubtitle}</span>
                    )}
                  </Box>
                )}
                {isMakerPage && (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Tooltip title="Abrir SQL IDE">
                      <IconButton
                        size="small"
                        onClick={() => navigate('/sql-ide')}
                        sx={{ 
                          bgcolor: 'rgba(255,255,255,0.1)', 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                          transition: 'all 0.2s ease'
                        }}
                      >
                        <StorageIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip 
                      title={
                        sidebarState === SIDEBAR_STATES?.EXPANDED 
                          ? "Recolher menu (só ícones)" 
                          : sidebarState === SIDEBAR_STATES?.COLLAPSED 
                            ? "Esconder menu"
                            : "Mostrar menu expandido"
                      }
                    >
                      <IconButton
                        size="small"
                        onClick={handleCycleSidebarState}
                        sx={{ 
                          bgcolor: 'rgba(255,255,255,0.1)', 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                          transition: 'all 0.2s ease'
                        }}
                      >
                        {sidebarState === SIDEBAR_STATES?.EXPANDED && '◀'}
                        {sidebarState === SIDEBAR_STATES?.COLLAPSED && '✕'}
                        {sidebarState === SIDEBAR_STATES?.HIDDEN && '▶'}
                      </IconButton>
                    </Tooltip>
                    <Typography
                      variant="caption"
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.15)',
                        px: 1,
                        py: 0.25,
                        borderRadius: 1,
                        fontSize: '0.7rem',
                        fontWeight: 500,
                        textTransform: 'uppercase',
                        letterSpacing: 0.5
                      }}
                    >
                      {sidebarState === SIDEBAR_STATES?.EXPANDED && 'Aberto'}
                      {sidebarState === SIDEBAR_STATES?.COLLAPSED && 'Ícones'}
                      {sidebarState === SIDEBAR_STATES?.HIDDEN && 'Oculto'}
                    </Typography>
                  </Box>
                )}
              </Typography>

              {/* Global Search Component */}
              <Box sx={{ mx: 2, display: { xs: 'none', sm: 'block' } }}>
                <GlobalSearch
                  menuJson={menuJson}
                  onNavigate={(option, action) => {
                    // console.log('Navegando para:', option);
                    closeAllSubmenuPopovers();

                    // Se for para abrir modal de entidades
                    if (action === 'modal' && option.id === 'config-entidades') {
                      setModalOpen(true);
                    }
                  }}
                />
              </Box>

              {/* Mobile Search Modal */}
              <GlobalSearchModal
                menuJson={menuJson}
                onNavigate={(option, action) => {
                  // console.log('Navegando para (mobile):', option);
                  closeAllSubmenuPopovers();

                  // Se for para abrir modal de entidades
                  if (action === 'modal' && option.id === 'config-entidades') {
                    setModalOpen(true);
                  }
                }}
              />

              <Tooltip
                title={<div style={{ whiteSpace: 'nowrap' }}>
                  <div><strong>application:</strong>&nbsp;{tooltipApp || '-'}</div>
                  <div><strong>systemVersion:</strong>&nbsp;{tooltipSystemVersion || '-'}</div>
                  <div><strong>systemVersionMaker:</strong>&nbsp;{tooltipSystemVersionMaker || '-'}</div>
                </div>}
                arrow
                placement="bottom"
              >
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                  {isProd && (
                    <Typography variant="caption" sx={{
                      mr: 1,
                      backgroundColor: '#fff',
                      color: '#b71c1c',
                      padding: '4px 10px',
                      borderRadius: 1,
                      fontWeight: 'bold',
                      fontSize: '0.75rem',
                      letterSpacing: 1,
                      border: '2px solid #ef9a9a',
                      animation: 'prod-blink 1.8s ease-in-out infinite',
                    }}>
                      ⚠ PRODUÇÃO
                    </Typography>
                  )}
                  <Button
                    href="/tenant"
                    className="tenant-link"
                    variant="contained"
                    disableElevation
                  >
                    {tenant}
                  </Button>
                  {makerVersion && (
                    <Typography variant="caption" sx={{ ml: 2, mr: 2, backgroundColor: '#ffc107', color: '#000', padding: '4px 8px', borderRadius: 1, fontWeight: 'bold' }}>
                      {makerVersion}
                    </Typography>
                  )}
                </span>
              </Tooltip>

              <IconButton
                color="inherit"
                id="configurations-menu-button"
                onClick={openSettingsMenu}
              >
                <SettingsIcon />
              </IconButton>
              <Menu
                anchorEl={anchorParams}
                open={Boolean(anchorParams)}
                onClose={handleMenuClose}
                PaperProps={{
                  sx: {
                    maxHeight: '80vh',
                    width: '280px',
                    '& .MuiMenuItem-root': {
                      minHeight: '40px',
                    }
                  }
                }}
              >
                {/* Centro de Criação */}
                <ListSubheader
                  sx={{
                    backgroundColor: '#f0f0f0',
                    fontWeight: 'bold',
                    color: '#782cdf',
                    lineHeight: '32px',
                    fontSize: '0.875rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <CreateOutlined fontSize="small" />
                  Centro de Criação
                </ListSubheader>

                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/json-editor");
                  }}
                  sx={{ pl: 4 }}
                >
                  <EditNoteIcon sx={{ mr: 2, fontSize: 20 }} />
                  Editor
                </MenuItem>

                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/formatReport");
                  }}
                  sx={{ pl: 4 }}
                >
                  <Assessment sx={{ mr: 2, fontSize: 20 }} />
                  Formatador/Relatórios
                </MenuItem>

                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/publish-version");
                  }}
                  sx={{ pl: 4 }}
                >
                  <Publish sx={{ mr: 2, fontSize: 20 }} />
                  Publicar Versão
                </MenuItem>

                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/version-update");
                  }}
                  sx={{ pl: 4 }}
                >
                  <Engineering sx={{ mr: 2, fontSize: 20 }} />
                  Atualização de Versão
                </MenuItem>

                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/maker/docs");
                  }}
                  sx={{ pl: 4 }}
                >
                  <HelpOutlineIcon sx={{ mr: 2, fontSize: 20 }} />
                  Documentação Maker
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    redirectModalOpen();
                  }}
                  sx={{ pl: 4 }}
                >
                  <TableBarIcon sx={{ mr: 2, fontSize: 20 }} />
                  Entidades
                </MenuItem>

                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/typeEdition");
                  }}
                  sx={{ pl: 4 }}
                >
                  <BuildOutlined sx={{ mr: 2, fontSize: 20 }} />
                  Scripts/Relatórios
                </MenuItem>

                <Divider sx={{ my: 1 }} />

                {/* Tags - Parâmetros */}
                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/parameterConfig");
                  }}
                >
                  <StyleIcon sx={{ mr: 2 }} />
                  Tags - Parâmetros
                </MenuItem>

                <Divider sx={{ my: 1 }} />

                {/* Permissões */}
                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/usuarioList");
                  }}
                >
                  <Security sx={{ mr: 2 }} />
                  Permissões
                </MenuItem>

                <Divider sx={{ my: 1 }} />

                {/* Sistemas SSO */}
                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/admin-sistemas");
                  }}
                >
                  <DnsSharp sx={{ mr: 2 }} />
                  Sistemas
                </MenuItem>

                {/* Contas de sistema (client credentials) — só o tenant dono do sistema gere */}
                {!isPersonalizationMode && (
                  <MenuItem
                    onClick={(e) => {
                      handleMenuClose();
                      closeSettingsMenu("/system-accounts");
                    }}
                  >
                    <VpnKey sx={{ mr: 2 }} />
                    Contas de sistema
                  </MenuItem>
                )}

                {/* Conferência NFS-e x Sefin (todos os tenants) — administração global, fora da personalização */}
                {!isPersonalizationMode && (
                  <MenuItem
                    onClick={(e) => {
                      handleMenuClose();
                      closeSettingsMenu("/conferencia-nfse");
                    }}
                  >
                    <FactCheck sx={{ mr: 2 }} />
                    Conferência NFS-e
                  </MenuItem>
                )}

                {/* Monitor de integrações (saúde dos serviços e integrações de todos os tenants) — só a equipe MyPlat */}
                {!isPersonalizationMode && (
                  <MenuItem
                    onClick={(e) => {
                      handleMenuClose();
                      closeSettingsMenu("/monitor-integracoes");
                    }}
                  >
                    <MonitorHeart sx={{ mr: 2 }} />
                    Monitor de integrações
                  </MenuItem>
                )}

                <Divider sx={{ my: 1 }} />

                {/* Wizard */}
                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/wizard");
                  }}
                >
                  <DesignServices sx={{ mr: 2 }} />
                  Wizard
                </MenuItem>

                <Divider sx={{ my: 1 }} />

                {/* Mensagens */}
                <ListSubheader
                  sx={{
                    backgroundColor: '#f0f0f0',
                    fontWeight: 'bold',
                    color: '#782cdf',
                    lineHeight: '32px',
                    fontSize: '0.875rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <NotificationsActive fontSize="small" />
                  Mensagens
                </ListSubheader>

                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/template");
                  }}
                  sx={{ pl: 4 }}
                >
                  <MessageIcon sx={{ mr: 2, fontSize: 20 }} />
                  Templates
                </MenuItem>

                <MenuItem
                  onClick={(e) => {
                    handleMenuClose();
                    closeSettingsMenu("/messagesDefinition");
                  }}
                  sx={{ pl: 4 }}
                >
                  <NotificationImportantIcon sx={{ mr: 2, fontSize: 20 }} />
                  Mensagens Automatizadas
                </MenuItem>
              </Menu>

              <IconButton color="inherit" onClick={handleMenuClick}>
                <AccountCircle />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    navigate("/profile");
                  }}
                >
                  Perfil
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    handleLogout();
                  }}
                >
                  Sair
                </MenuItem>
              </Menu>
              {((location?.pathname === "/home") || (location?.pathname || "").startsWith("/home/")) && (
                <BsButton variant="contained" onClick={handleEditEntity}>
                  <Tooltip title="Editar configuração da tela" arrow>
                    <span
                      style={{
                        fontWeight: "bold",
                        fontFamily: "monospace",
                        color: "#fff",
                        borderRadius: "4px",
                        fontSize: "1.9rem",
                      }}
                    >
                      &lt;&gt;
                    </span>
                  </Tooltip>
                </BsButton>
              )}
            </Toolbar>
          </AppBar>
        )}

        <Box
          sx={{
            flexGrow: 1,
            paddingLeft:
              isMobile || hideMenu || hide || menuState === MENU_STATES.HIDDEN
                ? 0
                : menuState === MENU_STATES.COLLAPSED
                  ? 8
                  : 30,
            backgroundColor: "#fafafa",
            overflow: "auto",
            transition: "padding-left 0.3s ease",
          }}
        >
          {children}
        </Box>
      </Box>

      {submenuPopovers.map((popover, popoverIndex) => (
        <Popover
          key={popover.id}
          className="nested-submenu-popover"
          open={popover.open}
          anchorEl={popover.anchorEl}
          onClose={() => closeSubmenuPopover(popover.level)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          sx={{
            zIndex: 1300 + popover.level,
            "& .MuiPopover-paper": {
              marginLeft: "8px",
              boxShadow: `0 ${Math.min(popover.level * 2, 8)}px ${Math.min(
                popover.level * 4,
                16
              )}px rgba(0,0,0,0.15)`,
              borderRadius: 2,
              overflow: "hidden",
              border: "1px solid rgba(0,0,0,0.1)",
              animation: "slideInFromLeft 0.2s ease-out",
            },
          }}
          disableRestoreFocus
          disableAutoFocus
          disableEnforceFocus
        >
          <Box
            sx={{
              backgroundColor: "#f4f4f4",
              minWidth: 200,
              maxWidth: 300,
              borderLeft:
                popover.level > 1
                  ? `3px solid rgba(120, 44, 223, ${Math.min(
                    popover.level * 0.2,
                    1
                  )})`
                  : "none",
            }}
            data-testid={`nested-submenu-popover-${popover.level}`}
          >
            <Typography
              variant="subtitle2"
              sx={{
                padding: "12px 16px",
                backgroundColor: "#782cdf",
                color: "white",
                fontWeight: "bold",
                margin: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>{popover.menuItem?.menu}</span>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  variant="caption"
                  className="submenu-level-indicator"
                >
                  Nível {popover.level}
                </Typography>
                {popover.level > 2 && (
                  <Typography
                    variant="caption"
                    sx={{
                      backgroundColor: "rgba(255, 193, 7, 0.9)",
                      color: "#000",
                      padding: "1px 4px",
                      borderRadius: "6px",
                      fontSize: "0.6rem",
                      fontWeight: "bold",
                    }}
                  >
                    PROFUNDO
                  </Typography>
                )}
              </Box>
            </Typography>
            <List dense sx={{ padding: 0 }}>
              {popover.childMenus?.map((childItem, index) => {
                const grandChildMenus = menuJson.filter(
                  (e) => e.parentmenu === childItem.menu
                );
                const hasGrandChildren = grandChildMenus.length > 0;

                return (
                  <ListItem
                    key={`${popover.id}_${index}`}
                    className="submenu-item"
                    data-submenu-item={childItem.menu}
                    sx={{
                      py: 1.5,
                      px: 2,
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      borderBottom:
                        index < popover.childMenus.length - 1
                          ? "1px solid #f0f0f0"
                          : "none",
                      position: "relative",
                      "&::before": hasGrandChildren
                        ? {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: "3px",
                          backgroundColor: "#782cdf",
                          opacity: 0,
                          transition: "opacity 0.2s ease",
                        }
                        : {},
                      "&:hover::before": hasGrandChildren
                        ? {
                          opacity: 1,
                        }
                        : {},
                    }}
                    onClick={(e) =>
                      handleNestedSubmenuClick(e, childItem, popover.level)
                    }
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      {getMenuIcon(childItem, popover.level)}
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                          <span>{childItem.menu}</span>
                          {renderShortcutBadge(childItem.key_board_short_cut)}
                        </Box>
                      }
                      sx={{
                        flex: 1,
                        "& .MuiListItemText-primary": {
                          fontSize: "0.875rem",
                          fontWeight: 500,
                          color: hasGrandChildren ? "#782cdf" : "inherit",
                        },
                      }}
                    />
                    {hasGrandChildren && (
                      <ChevronRight
                        className="submenu-arrow"
                        fontSize="small"
                        sx={{
                          color: "#782cdf",
                          opacity: 0.8,
                          transition: "all 0.2s ease",
                        }}
                      />
                    )}
                  </ListItem>
                );
              })}
            </List>
          </Box>
        </Popover>
      ))}
    </Box>
  );
};

export default SlimMenuBar;
